document.addEventListener('DOMContentLoaded', () => {
  const headerClass = 'header-main';
  const header = document.getElementById('site-header');
  const scrollThreshold = parseInt(header.dataset.scrollThreshold, 10) || 30;
  const listSubmenuLevel2 = document.querySelectorAll(
    '.header-main__list.menu-level-2'
  );

  const menuContent = document.querySelector(`.${headerClass}__menu-content`);

  if (menuContent) {
    listSubmenuLevel2.forEach((submenu) => {
      menuContent.appendChild(submenu);
    });
  }

  function toggleSubmenu(event) {
    const button = event.currentTarget;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const contentId = button.getAttribute('aria-controls');
    const submenu = document.getElementById(contentId);
    if (submenu) {
      button.setAttribute('aria-expanded', !isExpanded);
      submenu.setAttribute('aria-hidden', isExpanded);
      submenu.classList.toggle('is-open', !isExpanded);
    }
  }

  function clearSubmenuStates() {
    listSubmenuLevel2.forEach((submenu) => {
      submenu.classList.remove('is-open');
    });
    document.querySelectorAll('.header-main__menu-button').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function updateHeaderState() {
    const scrollTop = window.scrollY;

    if (scrollTop < scrollThreshold) {
      header.classList.add(`${headerClass}--initial`);
      header.classList.remove(`${headerClass}--scrolled`);
    } else {
      header.classList.remove(`${headerClass}--initial`);
      header.classList.add(`${headerClass}--scrolled`);
    }
  }

  // Hover state
  header.addEventListener('mouseenter', () => {
    header.classList.add(`${headerClass}--hovered`);
  });
  header.addEventListener('mouseleave', () => {
    header.classList.remove(`${headerClass}--hovered`);
    header.classList.remove(`${headerClass}--expanded`);
    // restore logo
    const logoExpanded = document.querySelector(
      `.${headerClass}__logo-wrapper[data-logo-expanded]`
    );
    const logoBig = document.querySelector(
      `.${headerClass}__logo-wrapper[data-logo-big]`
    );
    if (logoExpanded && logoBig) {
      logoExpanded.style.display = 'none';
      logoBig.style.display = 'block';
    }
    clearSubmenuStates();
  });

  // Expanded state
  document.querySelectorAll('.nav-item.has-submenu').forEach((item) => {
    item.addEventListener('mouseenter', (event) => {
      header.classList.add(`${headerClass}--expanded`);
      // replace logo
      const logoExpanded = document.querySelector(
        `.${headerClass}__logo-wrapper[data-logo-expanded]`
      );
      const logoBig = document.querySelector(
        `.${headerClass}__logo-wrapper[data-logo-big]`
      );
      if (logoExpanded && logoBig) {
        logoExpanded.style.display = 'block';
        logoBig.style.display = 'none';
      }

      clearSubmenuStates();
      toggleSubmenu(event);
    });
  });

  // Scroll listener
  window.addEventListener('scroll', updateHeaderState);
  updateHeaderState(); // Run on load

  // Load SVG logos
  const logoContainers = document.querySelectorAll(
    `.${headerClass}__logo-wrapper`
  );
  logoContainers.forEach((logoContainer) => {
    const svgUrl = logoContainer.dataset.svg;
    if (svgUrl) {
      fetch(svgUrl)
        .then((res) => res.text())
        .then((svg) => {
          logoContainer.innerHTML = svg;
        })
        .catch((err) => {
          console.warn('SVG load failed', err);
        });
    }
  });
});
